import { Checkbox } from '../seatSelector.style'

interface CheckboxProps {
    isChecked?: boolean
    onChange?: (checked: boolean) => void
}

const ComplimentaryCheckbox: React.FC<CheckboxProps> = ({ isChecked, onChange }: CheckboxProps) => (
    <Checkbox>
        <label>
            <input type="checkbox" checked={isChecked} onChange={(e) => onChange && onChange(e.target.checked)} />
            Tiszteletjegy
        </label>
    </Checkbox>
)

export default ComplimentaryCheckbox
